/** D-151: the in-app alert of the missed WhatsApp calls nobody took yet (dashboard). */

import "./calls.css";

import { useCallsSummaryRetrieve } from "@agencyos/api-client";
import { GlassCard } from "@agencyos/ui-web";
import { PhoneMissed } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function MissedCallsBanner({ enabled = true }: { enabled?: boolean }) {
  const { t } = useTranslation();
  const summary = useCallsSummaryRetrieve({ query: { enabled } });
  const count = summary.data?.status === 200 ? summary.data.data.missed_pending : 0;
  if (!count) return null;
  return (
    <GlassCard as="section" className="calls-banner" role="status">
      <span className="calls-banner__title">
        <PhoneMissed size={18} strokeWidth={1.75} aria-hidden="true" />
        {t("calls.banner.title", { count })}
      </span>
      <Link className="ao-button ao-button--secondary ao-button--sm" to="/calls">
        {t("calls.banner.open")}
      </Link>
    </GlassCard>
  );
}
